import { useEffect, useState } from "react";

const pageMonthSelection = new Map();
const SHARED_MONTH_SELECTION_KEY = "__agente_contabilidade_last_month__";

export function usePageMonthSelection(pageKey) {
  const [selectedMonth, setSelectedMonthState] = useState(
    () => pageMonthSelection.get(SHARED_MONTH_SELECTION_KEY) || pageMonthSelection.get(pageKey) || ""
  );

  useEffect(() => {
    if (selectedMonth) {
      pageMonthSelection.set(pageKey, selectedMonth);
      pageMonthSelection.set(SHARED_MONTH_SELECTION_KEY, selectedMonth);
    } else {
      pageMonthSelection.delete(pageKey);
    }
  }, [pageKey, selectedMonth]);

  return [selectedMonth, setSelectedMonthState];
}
